module.exports = __webpack_public_path__ + "img/hero2025.6db302d1.svg";